import { render, staticRenderFns } from "./index.vue?vue&type=template&id=634925a3&scoped=true&"
import script from "./index.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./index.vue?vue&type=script&charset=utf-8&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634925a3",
  null
  
)

export default component.exports